<template>
    <div :class="{ 'tw:space-y-1': isGroup }">
        <!-- Grupo con submenú -->
        <button v-if="isGroup" type="button" @click="$emit('toggle')" :aria-expanded="open ? 'true' : 'false'"
            :class="[itemClass, 'tw:w-full tw:justify-between tw:bg-transparent tw:border-0 tw:cursor-pointer']">
            <span class="tw:flex tw:items-center tw:gap-3 tw:min-w-0">
                <i :class="icon" class="tw:text-sm tw:w-4 tw:text-center tw:shrink-0"></i>
                <span class="tw:truncate" v-show="expanded">{{ title }}</span>
            </span>
            <i class="fas fa-chevron-right tw:text-sm tw:text-slate-500 tw:transition-transform tw:duration-200"
                :class="{ 'tw:rotate-90': open }"></i>
        </button>

        <!-- Enlace simple -->
        <router-link v-else :to="to" :class="itemClass" :title="title" @click.native="closeMobileSidebar">
            <i :class="icon" class="tw:text-sm tw:w-4 tw:text-center tw:shrink-0"></i>
            <span class="tw:truncate" v-show="expanded">{{ title }}</span>
        </router-link>

        <div v-if="isGroup" v-show="open" class="tw:py-1 tw:space-y-1"
            :class="expanded ? 'tw:pl-9 tw:pr-2' : 'tw:pl-0 tw:pr-0'">
            <router-link v-for="child in children" :key="child.to" :to="child.to"
                class="tw:block tw:py-1.5 tw:rounded-lg tw:no-underline tw:transition-colors tw:hover:text-slate-200 tw:hover:bg-slate-800/40 tw:truncate"
                :class="[isActive(child.routes) ? 'tw:text-primary tw:font-semibold tw:bg-primary/10' : 'tw:text-slate-300', expanded ? 'tw:text-sm tw:px-3' : 'tw:text-xs tw:px-1']"
                @click.native="closeMobileSidebar">
                <i class="fa fa-hashtag tw:mr-2" v-show="expanded"></i> {{ child.label }}
            </router-link>
        </div>
    </div>
</template>

<script>
import { closeMobileSidebar } from '@/plugins/sidebarStore';

export default {
    name: 'SidebarItem',
    props: {
        title: { type: String, required: true },
        icon: { type: String, default: '' },
        to: { type: String, default: '' },
        routes: { type: Array, default: () => [] },
        children: { type: Array, default: () => [] },
        // Sidebar ancho completo (muestra textos) o colapsado (solo iconos)
        expanded: { type: Boolean, default: true },
        // Estado abierto del submenú (solo grupos)
        open: { type: Boolean, default: false },
    },
    computed: {
        isGroup() {
            return this.children.length > 0;
        },
        itemClass() {
            return [
                'tw:flex tw:items-center tw:gap-3 tw:px-3.5 tw:py-2.5 tw:rounded-xl tw:text-sm tw:no-underline tw:transition-all tw:hover:bg-slate-800/70 tw:hover:text-slate-200',
                this.isActive(this.routes) ? 'tw:bg-primary/15 tw:text-primary tw:font-semibold' : 'tw:text-slate-300 tw:font-medium',
                this.expanded ? 'tw:px-3!' : 'tw:px-1! tw:justify-self-center'
            ];
        },
    },
    methods: {
        closeMobileSidebar,
        isActive(routes) {
            return routes.includes(this.$route.name);
        },
    },
}
</script>
